import React from "react";

type OffersProps = {
  offer?: OfferType;
};
type OfferType = {
  id?: string;
  title?: string;
  description?: string;
};

export const Offers = ({ offer }: OffersProps) => {
  if (!offer?.id) {
    return null;
  }

  return (
    <div className="Offers pt-[var(--panelPadding)] flex flex-wrap">
      <div className="OffersLabel font-bold">Offers:</div>
      <div className="customerRequestsHeader pl-1">{offer.title}</div>
      <div className="customerRequestsDescription pt-1 basis-full">
        {offer.description}
      </div>
    </div>
  );
};
